export const FE_REQUEST_TIMEOUT = -6;
export const NOT_LOGIN = 401;
export const NATIVE_REQUEST_TIMEOUT = -1;
export const PRE_DEAL_APR_LIMIT_EXCEEDED = 1038710046; // 预下单 APR错误
export const NAO_APR_LIMIT_EXCEEDED = 1038700006; // 还款计划试算APR错误
export const SPECIAL_CHAR_REGEXP = /[^a-zA-Z0-9/\-?:().,'+\s\n\u4e00-\u9fa5]/;
// 申请被拒绝
export const APPLICATION_REFUSE_CODE = 1039350021;
export const NOT_IN_TESLAWHITELIST = 1038850126;
// 用户没有香港身份证
export const NO_HONGKONG_IDCARD = 1038850155;
// 额度互斥
export const APPLICATION_MUTEX_CODE = 1039350062;
export const DEAL_TIME_OUT = [1613239612, 1613239615, 1613048606];
export var ProductInfoMap;
(function (ProductInfoMap) {
    ProductInfoMap["DEFAULT"] = "FyvFkIqLYfHM3ju";
    ProductInfoMap["TESLA"] = "tesla_realKHMw3ju";
    ProductInfoMap["INSTALLMENT"] = "inst_Qgfsj12Dm1";
})(ProductInfoMap || (ProductInfoMap = {}));
export var BaseProductNoMap;
(function (BaseProductNoMap) {
    BaseProductNoMap["DEFAULT"] = "L0000001";
    BaseProductNoMap["TESLA"] = "L0000002";
    BaseProductNoMap["INSTALLMENT"] = "L0000004";
})(BaseProductNoMap || (BaseProductNoMap = {}));
export var CarOwnerBusInfo;
(function (CarOwnerBusInfo) {
    CarOwnerBusInfo[CarOwnerBusInfo["TESLABUSSENESSTYPE"] = 20] = "TESLABUSSENESSTYPE";
    CarOwnerBusInfo[CarOwnerBusInfo["TESLAWHITELISTTYPE"] = 1] = "TESLAWHITELISTTYPE";
    CarOwnerBusInfo[CarOwnerBusInfo["NOTESLAWHITELISTTYPE"] = 2] = "NOTESLAWHITELISTTYPE";
})(CarOwnerBusInfo || (CarOwnerBusInfo = {}));
export const PRODUCT_CONTRACT_PREVIEW = {
    FyvFkIqLYfHM3ju: 'loanLimit',
    inst_Qgfsj12Dm1: 'loanLimitInstallment',
    tesla_realKHMw3ju: 'loanTesla,loanLimitTeslaSimple',
};
export var ProductType;
(function (ProductType) {
    ProductType["NPPTESLA"] = "NPP-TESLA";
    ProductType["NPP"] = "NPP";
    ProductType["INSTALLMENT"] = "INSTALLMENT";
})(ProductType || (ProductType = {}));
// export const PRODUCTTAGMAP: { [key: string]: string } = {
//   FyvFkIqLYfHM3ju: 'NPP',
//   inst_Qgfsj12Dm1: 'INSTALLMENT',
//   tesla_realKHMw3ju: 'NPPTESLA',
// };
export var PAYTYPE;
(function (PAYTYPE) {
    PAYTYPE["FUSOINPAY"] = "FUSOINPAY";
    PAYTYPE["WECHATPAY"] = "WECHATPAY";
    PAYTYPE["NONE"] = "NONE";
    PAYTYPE["BOTH"] = "BOTH";
})(PAYTYPE || (PAYTYPE = {}));
export const langMap = {
    'zh-HK': 'hk',
    'zh-CN': 'zh',
    'en-GB': 'en',
};
export var TRADECHANNEL;
(function (TRADECHANNEL) {
    TRADECHANNEL[TRADECHANNEL["WPHK_H5_INNNER"] = 121] = "WPHK_H5_INNNER";
    TRADECHANNEL[TRADECHANNEL["WPHK_H5_CASHIER"] = 122] = "WPHK_H5_CASHIER";
    TRADECHANNEL[TRADECHANNEL["APP_IOS_INNER"] = 301] = "APP_IOS_INNER";
    TRADECHANNEL[TRADECHANNEL["APP_ANDROID_INNER"] = 311] = "APP_ANDROID_INNER";
})(TRADECHANNEL || (TRADECHANNEL = {}));
